export const VERSION_LOCALHOST = "1.24.0";
export const VERSION_DEVELOP = "1.24.0(0)-DEV";
export const VERSION_STAGING = "1.24.0(0)-STG";
export const VERSION_PRODUCTION = "1.24.0";

export const VERSIONS = {
  localhost: VERSION_LOCALHOST,
  develop: VERSION_DEVELOP,
  staging: VERSION_STAGING,
  production: VERSION_PRODUCTION,
};
